/*************************************************/
/* PANEL                                         */
/*************************************************/
import customEventsNames from './../customEventsNames';
export function panel() {
    const init = () => {
        const panelButtons = document.querySelectorAll('.panel-button');
        const panelDivs = document.querySelectorAll('.panel-div');
        const panelOverlayMobileIcons = document.querySelectorAll('.panel-overlay--icon-mobile');
        const openClass = "open";
        const activeBodyClass = "panel-active";
        const menuButton = document.querySelector(".burger-menu");

        const getVimeoPlayer = (panelDiv) => {
            const iframe = panelDiv.querySelector('iframe');
            if (iframe && iframe.src.includes('vimeo.com')) {
                return new Vimeo.Player(iframe);
            }
            return null;
        };

        const togglePanel = (panelDiv, panelOverlayMobileIcon, panelButton) => {
            const isOpen = panelDiv.classList.toggle(openClass);
            panelDiv.setAttribute('aria-hidden', !isOpen);
            panelButton.setAttribute('aria-expanded', 'true');

            const panelOpened = new Event(customEventsNames.panelOpened);
            document.body.dispatchEvent(panelOpened);

            document.body.classList.add(activeBodyClass);
            const overlay = panelDiv.nextElementSibling;

            overlay.style.opacity = isOpen ? ".6" : "0";
            overlay.style.pointerEvents = "auto"; // Ensure clicks go through the overlay when it's hidden

            panelOverlayMobileIcon.style.display = isOpen ? "block" : "none";
            menuButton.style.opacity = isOpen ? "0" : "1";

            //Adding 2024 to the panel id value if the report is 2024
            let dataLayerPanelId = panelDiv.id;
            if(document.body.classList.contains('report--2024') && !dataLayerPanelId.endsWith('2024')){
                dataLayerPanelId = dataLayerPanelId + '2024';
            }

            //Push event to data layer
            window.dataLayer.push({
                'event': 'panelOpen',
                'panel': dataLayerPanelId
            });
        };

        const closePanel = (panelDiv, panelOverlayMobileIcon, panelButton) => {
            panelDiv.classList.remove(openClass);
            panelDiv.setAttribute('aria-hidden', 'true');
            panelButton.setAttribute('aria-expanded', 'false');
            document.body.classList.remove(activeBodyClass);

            const panelClosed = new Event(customEventsNames.panelClosed);
            document.body.dispatchEvent(panelClosed);

            const overlay = panelDiv.nextElementSibling;
            overlay.style.opacity = "0";
            overlay.style.pointerEvents = "none"; // Ensure clicks go through the overlay when it's hidden

            panelOverlayMobileIcon.style.display = "none";

            menuButton.style.opacity = "1";

            const player = getVimeoPlayer(panelDiv);
            if (player) {
                player.pause();
            }
        };

        panelButtons.forEach((panelButton, index) => {
            const panelDiv = panelDivs[index];
            const panelOverlayMobileIcon = panelOverlayMobileIcons[index];
            const panelButtonParent = panelButton.closest('.content-box__panel-button');

            // Register click on the .panel-button itself
            panelButton.addEventListener('click', (e) => {
                e.stopPropagation();
                togglePanel(panelDiv, panelOverlayMobileIcon, panelButton);
            });

            // Register click on the .content-box__panel-button div
            if (panelButtonParent) {
                panelButtonParent.addEventListener('click', (e) => {
                    e.stopPropagation();
                    togglePanel(panelDiv, panelOverlayMobileIcon, panelButton);
                });
            }

            panelDiv.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            document.body.addEventListener('click', (e) => {
                if (e.target.classList.contains('overlay')) {
                    closePanel(panelDiv, panelOverlayMobileIcon, panelButton);
                }
            });

            panelOverlayMobileIcon.addEventListener('click', (e) => {
                e.stopPropagation();
                closePanel(panelDiv, panelOverlayMobileIcon, panelButton);
            });
        });
    };

    init();
}
